import type {Schemas} from 'domainTypes/dto';
import {type Locale} from 'localization/types';
import {ebsApi} from 'store/ebsApi';
import type {
  Thesaurus,
  ThesaurusId,
  ThesaurusNode,
  ThesaurusNodeDto,
} from './types';
import {transformErrorResponse} from '../../store/api';
import {mapThesaurusDto} from './mappers';
import {mapGrepExtendedConceptDto} from './mappers/mapGrepExtendedConceptDto';

export const thesaurusApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getThesaurus: build.query<
      Thesaurus,
      {
        id: ThesaurusId;
        language: Locale;
      },
      ThesaurusNodeDto[]
    >({
      keepUnusedDataFor: 60 * 60 * 8,
      extraOptions: {maxRetries: 3},
      query: ({id, language}) => ({
        url: `thesaurus/${id}/export`,
        headers: {
          'Accept-Language': language,
        },
      }),
      transformErrorResponse: transformErrorResponse,
      transformResponse: (response, _, {id, language}) =>
        mapThesaurusDto(response, id, language),
    }),
    getGrepNodeDetails: build.query<
      ThesaurusNode,
      string,
      Schemas.GrepExtendedConcept
    >({
      keepUnusedDataFor: 60 * 60 * 8,
      query: code => ({
        url: `thesaurus/grep/${code}`,
      }),
      transformResponse: (response, _, code) =>
        mapGrepExtendedConceptDto(code, response),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetThesaurusQuery,
  useGetGrepNodeDetailsQuery,
  useLazyGetGrepNodeDetailsQuery,
} = thesaurusApi;
